import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadingTrue, loadingFalse } from "../Reducer/loaderSlice";
import Handler from "../Helpers/Handler";
import { toast } from "react-toastify";
import { Row, Col, Card, CardBody, Button, Input } from "reactstrap";

const Settings = () => {
    const dispatch = useDispatch();
    const loading = useSelector(s => s.loading.loading);

    const [form, setForm] = useState({
        invoice_format: "",
        quotation_format: ""
    });

    useEffect(() => {
        const fetchSettings = async () => {
            dispatch(loadingTrue());
            const res = await Handler({ method: "get", url: "/settings/get.php" });
            if (res?.success || res?.status) {
                setForm({
                    invoice_format: res.data?.invoice_format || "",
                    quotation_format: res.data?.quotation_format || ""
                });
            } else {
                toast.error("Failed to load settings");
            }
            dispatch(loadingFalse());
        };
        fetchSettings();
    }, [dispatch]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.invoice_format.trim() || !form.quotation_format.trim()) {
            return toast.error("Format fields cannot be empty");
        }

        dispatch(loadingTrue());
        const res = await Handler({
            method: "post",
            url: "/settings/save.php",
            data: form
        });

        if (res?.success || res?.status) {
            toast.success("Settings saved successfully!");
        } else {
            toast.error(res?.message || "Failed to save settings");
        }
        dispatch(loadingFalse());
    };

    return (
        <div className="page-card p-4 bg-white rounded-4 shadow-sm">
            <h4 className="fw-bold mb-4 border-bottom pb-2 text-primary">System Settings</h4>
            
            <form onSubmit={handleSubmit}>
                <Card className="mb-4 border-0 rounded-4 shadow-sm border-start border-5 border-primary bg-light">
                    <CardBody>
                        <Row className="g-3">
                            <Col md={6}>
                                <div className="form-group mb-3">
                                    <label className="fw-bold text-dark mb-1">Invoice Number Auto-Generation Format</label>
                                    <Input
                                        type="text"
                                        placeholder="e.g. INV-{YYYY}-{XXXX}"
                                        value={form.invoice_format}
                                        onChange={(e) => setForm({ ...form, invoice_format: e.target.value })}
                                        required
                                    />
                                    <small className="text-muted d-block mt-2">
                                        Use placeholders: 
                                        <code className="mx-1">{`{YYYY}`}</code> (4-digit Year), 
                                        <code className="mx-1">{`{YY}`}</code> (2-digit Year), 
                                        <code className="mx-1">{`{MM}`}</code> (2-digit Month), 
                                        <code className="mx-1">{`{XXXX}`}</code> (padded sequential counter, where the number of X's sets the digit count).
                                    </small>
                                </div>
                            </Col>

                            <Col md={6}>
                                <div className="form-group mb-3">
                                    <label className="fw-bold text-dark mb-1">Quotation Number Auto-Generation Format</label>
                                    <Input
                                        type="text"
                                        placeholder="e.g. SFS-{YYYY}-{XXXX}"
                                        value={form.quotation_format}
                                        onChange={(e) => setForm({ ...form, quotation_format: e.target.value })}
                                        required
                                    />
                                    <small className="text-muted d-block mt-2">
                                        Use same placeholders: 
                                        <code className="mx-1">{`{YYYY}`}</code>, 
                                        <code className="mx-1">{`{YY}`}</code>, 
                                        <code className="mx-1">{`{MM}`}</code>, 
                                        <code className="mx-1">{`{XXXX}`}</code>.
                                    </small>
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>

                <div className="text-end">
                    <Button color="primary" size="lg" className="px-5 rounded-pill shadow-lg shadow-primary" type="submit" disabled={loading}>
                        {loading ? "Saving..." : "Save Settings"}
                    </Button>
                </div>
            </form>
        </div>
    );
};

export default Settings;
